<!--
 * @Description: 自助签到
 * @Author: 山淑兰
 * @Date: 2019-11-26 14:05:58
 * @LastEditTime: 2020-07-02 14:20:28
 * @LastEditors: 山淑兰
 -->
<template>
  <div id="selfSignin">
    <div class="loading" v-if="loading">
      <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
    </div>
    <div v-else>
      <div class="selfSignin_content">
        <div class="selfSignin_title">
          <h2>{{title}}</h2>
          <p class="subheading">{{subheading}}</p>
        </div>
        <div class="selfSignin_main">
          <div>
            <p>报名手机号</p>
          </div>
          <div class="telNum">
            <input type="text" class="telNumInp" v-model="telVal" @change="reNum" @input="signIn" />
          </div>
          <div class="selfSignin_sure_btn" @click="submit">确认签到</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "selfSignin",
  data() {
    return {
      loading: false,
      params: { code: "" }, // code唯一标识
      subheading: '活动签到',
      telVal: "",

    }
  },
  methods: {
    async init() {
      try {
        this.loading = true
        const { params } = this;
        const res = await this.$http.initMeetingInfo(params);
        console.log("会议基本信息", res)
        this.title = res.MeetingTitle;
        this.loading = false

      } catch (error) {
        console.error(error);
      }
    },
    reNum() {
      let telVal = this.telVal
      let re = /^1[1-9]\d{9}$/
      let reTel = re.test(telVal)
      if (reTel === false) {
        this.$notify({
          message: '请输入正确的手机号!',
          type: 'danger',
        });
      }
    },
    signIn() {
      this.telVal = this.telVal.replace(/[^\d]/g, '')
      // let loginBtn = document.querySelector('.login-btn')
      // if (this.CAPTCHA !== '' && this.telVal !== '') {
      //   loginBtn.style.opacity = '1'
      // } else {
      //   loginBtn.style.opacity = '0.6'
      // }
    },
    submit() {
      const {code} =this.params
      this.$router.push({
        path: "selfSigninSucceeded",
        query: { code }
      });
    }
  },
  created() {
    const { code } = this.$route.query;
    this.params.code = code;
    this.init();
  }
}
</script>

<style lang="scss" scoped>
#selfSignin {
  // background: #fff;
  // min-height: 700px;
  .selfSignin_content {
    width: 96%;
    margin: 0 auto;
    .selfSignin_title {
      font-size: 40px;
      text-align: center;
      padding: 40px 0px;
      .subheading {
        font-size: 36px;
        color: #1e293b;
        line-height: 80px;
      }
    }
    .selfSignin_main {
      width: 90%;
      margin: 0 auto;
      font-size: 30px;
      .telNum {
        margin-top: 10px;
        margin-bottom: 40px;
        .telNumInp {
          width: 100%;
          height: 70px;
          font-size: 32px;
          box-sizing: border-box;
          border-radius: 8px;
          background: #fff;
          padding-left: 20px;
          // border: 2px solid #3b82f6;
          box-shadow: 0 2px 12px rgba(0,0,0,0.04);

          &:focus {
            box-shadow: 0 0 2px #3b82f6;
          }
        }
      }
      .selfSignin_sure_btn {
        width: 100%;
        height: 80px;
        background: #3b82f6;
        color: #fff;
        border-radius: 8px;
        text-align: center;
        line-height: 80px;
        font-size: 34px;
      }
    }
  }
}
</style>